import * as React from "react";
import { AppHeader } from "@duosoftbg/nacid-frontoffice-components";

const Header = () => {
  return <AppHeader />;
};
export default Header;
